import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import AG_GRID_LOCALE_ES from "~/components/grid/agGridLocaleEs";
import { normalizeLanguage } from "~/i18n/languagePreference";

const useAgGridLocaleText = (): Record<string, string> | undefined => {
	const { i18n } = useTranslation();
	const language = normalizeLanguage(i18n.resolvedLanguage ?? i18n.language);
	return useMemo(() => (language === "es" ? AG_GRID_LOCALE_ES : undefined), [language]);
};

export default useAgGridLocaleText;
